module.exports = "./img/8441aadfe4b8b183dc7262345cf271ce.jpg";